import { render, staticRenderFns } from "./r-item-kind-table.vue?vue&type=template&id=a880cd5a"
import script from "./r-item-kind-table.vue?vue&type=script&lang=js"
export * from "./r-item-kind-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a880cd5a')) {
      api.createRecord('a880cd5a', component.options)
    } else {
      api.reload('a880cd5a', component.options)
    }
    module.hot.accept("./r-item-kind-table.vue?vue&type=template&id=a880cd5a", function () {
      api.rerender('a880cd5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-kind-table.vue"
export default component.exports